import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../providers/auth0-instance";
import { withErrorNotification } from "../notifications";

interface MapApiKeyResponse {
  arcgis_key: string;
}

export const configApi = createApi({
  reducerPath: "configApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Config"],
  endpoints: (builder) => ({
    getMapApiKey: builder.query<MapApiKeyResponse, void>({
      query: () => ({ url: "/config/map-api-key" }),
      providesTags: ["Config"],
      onQueryStarted: withErrorNotification("Failed to fetch map API key"),
    }),
  }),
});

export const { useGetMapApiKeyQuery } = configApi;
